import React from "react";
import "./style.scss";

type PropsType = {
  className?: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
};

const ToggleCheckbox: React.FC<PropsType> = ({
  checked,
  onChange,
  className,
}) => {
  return (
    <label className={`toggle-checkbox ${className}`}>
      <input
        type="checkbox"
        checked={checked}
        onChange={() => onChange(!checked)}
      />
      <span className="slider" />
    </label>
  );
};

export default ToggleCheckbox;
